const NotFound = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center text-center bg-gray-100">
            <h1 className="text-6xl font-bold text-gray-800">404</h1>
            <p className="text-lg text-gray-600 mt-4">The page you are looking for is not available.</p>
        </div>
    );
};

export default NotFound;
